function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M30.336,12.547l-10.172-1.073L16,2.131l-4.164,9.343L1.664,12.547l7.599,6.847L7.141,29.4L16,24.289l8.859,5.111 l-2.122-10.007L30.336,12.547z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/star.68b75172.svg";
export { SvgComponent as ReactComponent };